import { useMemo, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { useTexture } from '@react-three/drei'
import * as THREE from 'three'

const COUNT = 600

export function AmbientParticles() {
  const ref = useRef()
  const tex = useTexture('/cv/textures/circle_01.png')

  const { positions, randoms } = useMemo(() => {
    const positions = new Float32Array(COUNT * 3)
    const randoms = new Float32Array(COUNT)
    for (let i = 0; i < COUNT; i++) {
      positions[i * 3 + 0] = (Math.random() - 0.5) * 60
      positions[i * 3 + 1] = (Math.random() - 0.5) * 40
      positions[i * 3 + 2] = (Math.random() - 0.5) * 40
      randoms[i] = Math.random()
    }
    return { positions, randoms }
  }, [])

  useFrame(({ clock }) => {
    if (!ref.current) return
    ref.current.rotation.y = clock.getElapsedTime() * 0.01
    ref.current.rotation.x = Math.sin(clock.getElapsedTime() * 0.005) * 0.1
  })

  return (
    <points ref={ref}>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" array={positions} count={COUNT} itemSize={3} />
      </bufferGeometry>
      <pointsMaterial
        map={tex}
        size={0.12}
        transparent
        opacity={0.25}
        depthWrite={false}
        sizeAttenuation
        color="#6366f1"
        blending={THREE.AdditiveBlending}
      />
    </points>
  )
}
